/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiAttributionTagFromJSON, ApiAttributionTagToJSON, } from './ApiAttributionTag';
import { ApiBucketGroupPayloadFromJSON, ApiBucketGroupPayloadToJSON, } from './ApiBucketGroupPayload';
export function ApiBucketResponseFromJSON(json) {
    return ApiBucketResponseFromJSONTyped(json, false);
}
export function ApiBucketResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'groups': !exists(json, 'groups') ? undefined : (json['groups'].map(ApiBucketGroupPayloadFromJSON)),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'tags': !exists(json, 'tags') ? undefined : (json['tags'].map(ApiAttributionTagFromJSON)),
    };
}
export function ApiBucketResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'groups': value.groups === undefined ? undefined : (value.groups.map(ApiBucketGroupPayloadToJSON)),
        'id': value.id,
        'name': value.name,
        'tags': value.tags === undefined ? undefined : (value.tags.map(ApiAttributionTagToJSON)),
    };
}
